import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { IS_DEVELOPMENT_MODE_TEST } from "../constants";
import fetchV2FeatureFlag from "./v2";
import fetchV5FeatureFlag from "./v5";
function fetchFlag(_x, _x2, _x3) {
  return _fetchFlag.apply(this, arguments);
}
function _fetchFlag() {
  _fetchFlag = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(flagKey, apiVersion, args) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!IS_DEVELOPMENT_MODE_TEST) {
            _context.next = 5;
            break;
          }
          _context.next = 4;
          return import("../__mocks__/fetchFlagMock").then(function (_ref) {
            var fetchFlagMock = _ref["default"];
            return fetchFlagMock(flagKey, apiVersion);
          });
        case 4:
          return _context.abrupt("return", _context.sent);
        case 5:
          if (!(apiVersion === 'V5')) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", fetchV5FeatureFlag({
            flagKey: flagKey,
            organizationId: args.organizationId
          }));
        case 9:
          if (!(apiVersion === 'V2')) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", fetchV2FeatureFlag({
            flagKey: flagKey
          }));
        case 11:
          _context.next = 17;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          console.error('Error fetching flag', flagKey, _context.t0);
          return _context.abrupt("return", {
            flagKey: flagKey,
            flagValue: false,
            apiVersion: apiVersion,
            error: _context.t0
          });
        case 17:
          return _context.abrupt("return", {
            flagKey: flagKey,
            flagValue: false,
            apiVersion: apiVersion,
            error: new Error('Unknown source')
          });
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  }));
  return _fetchFlag.apply(this, arguments);
}
export default fetchFlag;